import { useContext } from 'react';
import './Notifications.css';
import { ErrorContext } from '../../Contexts/ErrorContexts';
const parse = require('html-react-parser');

const Notifications = () => {
    const {notif} = useContext(ErrorContext);

    return <div className="notification" style={{borderLeftColor: notif.fillColor, backgroundColor: `rgba(${notif.backColor},0.5)`}}>
        
        <div className="content">

            {parse(notif.svgType)}
            
            <div className="message">
                <span className="message1">{notif.errorType}</span>
                <span className="message2">{notif.errorMsg}</span>
            </div>
        </div>
        
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 16 16" className="close" >
            <path d="M15.854 12.854c-0-0-0-0-0-0l-4.854-4.854 4.854-4.854c0-0 0-0 0-0 0.052-0.052 0.090-0.113 0.114-0.178 0.066-0.178 0.028-0.386-0.114-0.529l-2.293-2.293c-0.143-0.143-0.351-0.181-0.529-0.114-0.065 0.024-0.126 0.062-0.178 0.114 0 0-0 0-0 0l-4.854 4.854-4.854-4.854c-0-0-0-0-0-0-0.052-0.052-0.113-0.090-0.178-0.114-0.178-0.066-0.386-0.029-0.529 0.114l-2.293 2.293c-0.143 0.143-0.181 0.351-0.114 0.529 0.024 0.065 0.062 0.126 0.114 0.178 0 0 0 0 0 0l4.854 4.854-4.854 4.854c-0 0-0 0-0 0-0.052 0.052-0.090 0.113-0.114 0.178-0.066 0.178-0.029 0.386 0.114 0.529l2.293 2.293c0.143 0.143 0.351 0.181 0.529 0.114 0.065-0.024 0.126-0.062 0.178-0.114 0-0 0-0 0-0l4.854-4.854 4.854 4.854c0 0 0 0 0 0 0.052 0.052 0.113 0.090 0.178 0.114 0.178 0.066 0.386 0.029 0.529-0.114l2.293-2.293c0.143-0.143 0.181-0.351 0.114-0.529-0.024-0.065-0.062-0.126-0.114-0.178z"></path>
        </svg>

        <div className="progress" style={{backgroundColor: notif.fillColor}}></div>
    </div>
}

export default Notifications;